<template>
  <footer class="">
    <div class="w-full h-96 overflow-hidden relative">
      <div
        class="absolute w-full h-full bg-violet-800 mt-56"
        style="transform: scale(2) rotate(2deg)"
      ></div>
      <div class="absolute w-full">
        <div class="flex flex-col items-center mt-24 space-y-9 text-gray-200">
          <h1 class="text-xl font-extrabold tracking-wider">Yell Yint Aung</h1>
          <div class="flex space-x-4">
            <a href="https://www.facebook.com/profile.php?id=100016083194125"
              ><img class="w-7 md:w-10" src="images/facebook-logo.png" alt=""
            /></a>
            <a href="https://github.com/yya-yell"
              ><img class="w-7 md:w-10" src="images/github.png" alt=""
            /></a>
          </div>
          <p class="text-xs md:text-base">
            &copy;yellyintaung.All rights served.
          </p>
        </div>
      </div>
      <div class="invisible lg:visible lg: absolute -bottom-10 lg:left-20 -z-1">
        <img src="images/footer_image.svg" class="lg:w-64 xl:w-full" alt="" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>